import { Component, OnInit } from '@angular/core';
import {collection, collectionData, Firestore, limit, orderBy, query} from '@angular/fire/firestore';

@Component({
    selector: 'app-list-overview',
    templateUrl: './list-overview.component.html',
    styleUrls: ['./list-overview.component.scss'],
    standalone: false
})
export class ListOverviewComponent implements OnInit {

  lists;

  constructor(firestore: Firestore) {
    this.lists = collectionData(
      query(collection(firestore, 'lists-new'), orderBy('created', 'desc'), limit(10)),
      { idField: 'id' }
    );
  }

  ngOnInit(): void {
  }

}
